import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SiaTextBoxComponent } from '@sia/inputs';
import { SiaTranslatePipe } from '@sia/shared';

@Component({
  selector: 'sia-action-rename-dialog',
  standalone: true,
  imports: [
    SiaTextBoxComponent,
    MatButton,
    MatDialogTitle,
    MatDialogActions,
    MatDialogModule,
    SiaTranslatePipe,
    MatIcon,
  ],
  templateUrl: './sia-action-rename-dialog.component.html',
  styleUrl: './sia-action-rename-dialog.component.scss',
})
export class SiaActionRenameDialogComponent {
  actionName = inject(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<SiaActionRenameDialogComponent>>(MatDialogRef);

  /** Inserted by Angular inject() migration for backwards compatibility */

  /**
   *
   */
  constructor() {}

  closeDialog() {
    this.dialogRef.close(this.actionName);
  }
  saveAction() {
    this.dialogRef.close(this.actionName);
  }
}
